import { AxiosClient } from '@pole/client/agromarket'
import { CanceledError } from 'axios'
import { reduxStore } from '@/api/client/base'
import constants from '@/api/client/constants'
import { history } from '@/browserHistory'
import { closeModal, openModal } from '@/components/composed/Modal/actions'
import { getJwt } from '@/logic/auth/reducer'
import { ECommonRoute } from '@/types'
import { ExecutionEnvironment } from '@/utils/ExecutionEnvironment'

const { isSsr } = ExecutionEnvironment

const baseURL = isSsr ? `${process.env.API_HOST}:${process.env.API_PORT}` : ''

export const registerMonolithAxiosClient = () => {
  AxiosClient.registerApi('monolith', { baseURL, timeout: Number(process.env.API_RESPONSE_TIMEOUT) || 60_000 })
}

const monolithAxiosClient = AxiosClient.getClient({
  apiName: 'monolith',
  onRequest: config => {
    if (!reduxStore.store) return config

    const reduxToken = getJwt()(reduxStore.store?.getState?.())
    if (!config.headers.Authorization && !!reduxToken?.length) config.headers.Authorization = `Bearer ${reduxToken}`

    return config
  },
  onResponseError: data => {
    if (isSsr) return Promise.reject(data)

    const requestUrl = data?.config?.url ? new URL(data.config.url, window.location.origin).pathname : ''

    if (requestUrl?.includes('purchase-tenders')) {
      if (constants.tenders.allowedApiUrls.includes(requestUrl)) {
        reduxStore.store?.dispatch(
          openModal({
            options: {
              dialogId: 'ErrorApiModal',
              shouldCloseOnMissingClick: false,
            },
            contentOptions: {
              message: (data.response?.data as Record<string, string> | undefined)?.message || constants.tenders.apiErrorTitle,
              responseId: (data.response?.data as Record<string, string> | undefined)?.response_id || '',
              onSupport: () => history.push(ECommonRoute.feedback),
              onConfirm: () => reduxStore.store?.dispatch(closeModal()),
            },
          }),
        )
      }
    }

    return Promise.reject(data)
  },
})

export * from './types'
export { CanceledError }
export default monolithAxiosClient
